import { FC } from 'react'
import { IonGrid, IonRow } from '@ionic/react'
import { ImageSizePreset } from 'common_lib/types'
import { Button } from '@mytours/components'
import { getPurchasedContentUrl } from 'mobile_web/modules/navigation/routes'
import { getDirMode } from 'mobile_web/modules/platform'
import { usePurchasedContent } from '../usePurchasedContent'
import PurchasedContentCard from './PurchasedContentCard'
import strings from '../../../strings'
import './PurchasedContentBlock.less'

// Recent purchased/redeemed content on the Profile (or Settings). Mirrors FavouriteGroupBlock — the
// same grid of CardImage cards — with a Browse all link added to the header. Hidden when empty.
const PurchasedContentBlock: FC = () => {
	const { recent } = usePurchasedContent()

	if (recent.length === 0) {
		return null
	}

	// Rendered twice, one shown per breakpoint: on the title line (mobile) and above the items (desktop).
	const renderBrowseAll = (className: string): JSX.Element => (
		<Button
			as="a"
			variant="clear"
			className={`browse-all ${className}`}
			aria-label={strings.browse_all}
			href={getPurchasedContentUrl()}
		>
			{strings.browse_all}
		</Button>
	)

	return (
		<IonGrid dir={getDirMode()} className="block purchased-content-block">
			<div className="block-header">
				<h2 className="subheading">{strings.purchased_content}</h2>
				{renderBrowseAll('browse-all-inline')}
			</div>
			<div className="block-body">
				<div className="block-actions">{renderBrowseAll('browse-all-stacked')}</div>
				<IonRow className="block-content">
					{recent.map(item => (
						<PurchasedContentCard key={item.key} item={item} imageSizePreset={ImageSizePreset.Grid} />
					))}
				</IonRow>
			</div>
		</IonGrid>
	)
}

export default PurchasedContentBlock
